import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayContainsElement'
})
export class ArrayContainsElementPipe implements PipeTransform {

  transform(array: any[], searchElement: any, property: string): boolean {
    if (!array?.length || !searchElement || !property) {
      return false;
    }

    return array.some(item => item[property] === searchElement[property]);
  }

}
